export default __webpack_public_path__ + "static/media/Greaves of the Fallen Empire.1efc8daa.jpg";